// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___1b536a5f034e785be51","cls2":"SimplePaperPodcast-cls2__ef58306ebf827e92b0eb SimplePaperPodcast-cls1___1b536a5f034e785be51"};